import React, { useEffect } from 'react';
import { Box, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText } from '@mui/material';
import { TrendingUpRounded } from '@mui/icons-material';
import { BrandContext } from '../../App';
import { useTheme } from '@mui/material/styles';

const ExerciseRecommendations = ({ scenarioData }) => {
    const theme = useTheme()
    const { brand, authToken, simulations, fetchRecentSimulationsForScenario } = React.useContext(BrandContext);
    const [recommendations, setRecommendations] = React.useState([]);

    useEffect(() => {
        const loadSimulations = async () => {
            let simulationsData = [];
            if (scenarioData?.id) {
                simulationsData = await fetchRecentSimulationsForScenario(scenarioData.id, 5);
            } else {
                simulationsData = simulations?.recentWithEvaluation || [];
            }
            if (!Array.isArray(simulationsData) || simulationsData.length === 0) return;

            const latestValidSim = simulationsData[0];
            if (!latestValidSim || !latestValidSim.evaluation) return;

            const recs = [];
            for (const key in latestValidSim.evaluation) {
                const section = latestValidSim.evaluation[key];
                if (typeof section === 'object' && Array.isArray(section.recommendations)) {
                    const selected = section.recommendations.filter((_, i) => i % 3 === 0);
                    recs.push(...selected);
                }
            }

            setRecommendations(recs);
        };

        loadSimulations();
    }, [scenarioData?.id, simulations?.recentWithEvaluation, fetchRecentSimulationsForScenario]);

    return (
        <Box sx={{
            flex: 1,
            padding: theme.customSpacing['3xl'],
            boxShadow: '0px 12px 16px -4px rgba(0, 91, 140, 0.10), 0px 4px 6px -2px rgba(0, 91, 140, 0.03), 0px 2px 2px -1px rgba(0, 91, 140, 0.04)',
            border: `2px solid`,
            borderColor: theme.palette.border.tertiary,
            borderRadius: theme.shape.radius,
        }}>
            <Typography sx={{
                fontSize: theme.typography.textXL.fontSize,
                fontWeight: theme.typography.fontWeightMedium,
            }}>Try these recommendations 💪</Typography>
            <List dense sx={{ width: '100%' }}>
                {recommendations.map((item, index) => (
                    <ListItem key={`recommendation-${index}`} sx={{ padding: 0, margin: `${theme.customSpacing.md} 0` }}>
                        <ListItemAvatar>
                            <Avatar
                                variant="square"
                                sx={{
                                    backgroundColor: theme.palette.background.button_primary,
                                    color: theme.palette.background.primary,
                                    borderRadius: theme.shape.radius,
                                }}
                            >
                                <TrendingUpRounded />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={item} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default ExerciseRecommendations;
